/**
* Wiggly Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Wiggly Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'wiggly-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.wiggly-marquee .controls button' ).on( 'click', function() {
        if ( $( this ).hasClass( 'is-paused' ) ) {
          $( this )
              .attr( 'title', 'Pause marquee' )
              .attr( 'aria-pressed', 'false' )
              .removeClass( 'is-paused' );
          $( '.wiggly-marquee .is-motion-safe' ).show();
          $( '.wiggly-marquee .is-reduced-motion' ).hide();
        } else {
          $( this )
              .attr( 'title', 'Play marquee' )
              .attr( 'aria-pressed', 'true' )
              .addClass( 'is-paused' );
          $( '.wiggly-marquee .is-motion-safe' ).hide();
          $( '.wiggly-marquee .is-reduced-motion' ).show();
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'wiggly-marquee', COMPONENT );
} )( app );
